export const calcPosition = (width: number): [number, number] => {
	let position: [number, number] = [47.75, 29.3698];

	switch (true) {
		case width > 1000:
			position = [47.75, 29.3698];
			break;

		case width > 800:
			position = [47.75, 28.8];
			break;

		case width > 280:
			position = [47.75, 28.5];
			break;

		default:
			position = [47.75, 29.3698];
			break;
	}

	return position;
};
